import React, { useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminPanel from './pages/AdminPanel';
import LoginPage from './pages/LoginPage';
import StoreDetailsPage from './pages/StoreDetailsPage';
import DonationRequestPage from './pages/DonationRequestPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SupportInfo from './pages/SupportInfo';
import ProtectedRoute from './components/ProtectedRoute';
import { getUserRoleAndStoreId } from './utils/auth';

const StoreWrapper = ({ storeId }) => {
  // State to hold profile data shared across store pages and header
  const [profile, setProfile] = useState({
    storeName: '',
    profilePicture: '',
  });

  return (
    <StoreDetailsPage
      storeId={storeId}
      profile={profile}
      setProfile={setProfile}
    />
  );
};


function App() {
  const { role, storeId } = getUserRoleAndStoreId();

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            role === 'superadmin' ? (
              <Navigate to="/admin" replace />
            ) : role === 'store_owner' && storeId ? (
              <Navigate to={`/store/${storeId}`} replace />
            ) : role === 'store_manager' && storeId ? (
              <Navigate to={`/store/${storeId}`} replace />
            ) : (
              <LoginPage />
            )
          }
        />
        
        {/* Public Routes */}
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/support" element={<SupportInfo />} />
        <Route path="/donation/:storeId" element={<DonationRequestPage />} />
        
        {/* Protected Routes */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute requiredRole="superadmin">
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/store/:storeId"
          element={
            <ProtectedRoute requiredRoles={['store_owner', 'store_manager']}>
              <StoreWrapper storeId={storeId} />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;